import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { themes } from './DownloadLinksList.themes';
export type DownloadLinksListItem = {
  iconName?: string;
  label: string;
  onClick?: () => void;
  target?: '_blank' | '_self';
  trackingData?: TrackingData;
  url: string;
};
type Props = {
  className?: string;
  links: Array<DownloadLinksListItem>;
  text?: string;
  theme?: keyof typeof themes;
};
export const DownloadLinksList = ({ className, links = [], text, theme = 'default' }: Props) => {
  const track = useTracking();

  if (!links.length) {
    return null;
  }

  const {
    thLabel,
    thLabelIconSize,
    thLink,
    thList,
    thListItem,
    thListItemIcon,
    thListItemIconSize,
    thRoot,
    thText,
  } = themes[theme];
  return (
    <section className={classnames(thRoot, className)}>
      {!!text && (
        <div className={thLabel}>
          <Icon className="shrink-0 text-sienna" name={ICONS.DOWNLOAD} width={thLabelIconSize} />
          <Text className={thText} text={text} />
        </div>
      )}
      <ul className={thList}>
        {links.map(
          ({ iconName, label, onClick, target, trackingData, url }) =>
            url &&
            label && (
              <li className={thListItem} key={label}>
                <Icon className={thListItemIcon} name={iconName} width={thListItemIconSize} />
                <DynamicLink
                  className={thLink}
                  onClick={() => {
                    onClick?.();
                    trackingData && track(trackingData);
                  }}
                  target={target}
                  url={url}
                >
                  {label}
                </DynamicLink>
              </li>
            ),
        )}
      </ul>
    </section>
  );
};
